import BasePageFilter from '@/domains/BasePageFilter/BasePageFilter';
import Person         from "@/domains/Persons/Person";

class TransportOrdersRegistryFilter extends BasePageFilter {
    static Events = {
        Updated: 'transport-orders-complex-registry-filter:updated',
    } as const;

    protected storageKey = 'filters:transport-orders-complex-registry';

    responsible: Person;
    type: { id: string; name: string };

    reset(): void {
        if (this.isLocked('responsible') === false) {
            this.responsible = undefined;
        }

        if (this.isLocked('type') === false) {
            this.type = undefined;
        }
    }

    protected deserialize(json: string): void {
        const parsed = JSON.parse(json);

        if (this.isLocked('responsible') === false) {
            this.responsible = parsed.responsible;
        }

        if (this.isLocked('type') === false) {
            this.type = parsed.type;
        }
    }

    getRequestParams(): Record<string, any> {
        const params: any = {};

        if (this.responsible?.id) {
            params.responsible = { id: this.responsible.id };
        }

        if (this.type?.id) {
            params.type = this.type.id;
        }

        return params;
    }
}

export default TransportOrdersRegistryFilter;
